// store/Plans/PlansReducer.js
import * as actionTypes from "../ActionTypes";

const initialState = {
  plans: [],
  planDetails: null,
  loading: false,
  success: false,
  error: null,
};

const plansReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ================= SAVE PLAN ================= */
    case actionTypes.SAVE_PLAN_CHURCH_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case actionTypes.SAVE_PLAN_CHURCH_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case actionTypes.SAVE_PLAN_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    /* ================= READ PLAN ================= */
    case actionTypes.READ_PLAN_CHURCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.READ_PLAN_CHURCH_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: action.payload?.data || [],
      };

    case actionTypes.READ_PLAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /* ================= SAVE DAY PLAN ================= */
    case actionTypes.SAVE_DAY_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case actionTypes.SAVE_DAY_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case actionTypes.SAVE_DAY_PLAN_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default plansReducer;
